<template>
  <div style="width: 100%; height: 100%;display:flex">
    <div class="mapWrap" >
      <iframe id="mapframe" src="../../../static/EvMap/index.html?name=John" width="100%" height="100%" style="border: 0px"></iframe>
    </div>
    <div class="contentWrap">
      <div class="openLeftBtn" v-show="!openLeft" @click="()=>{openLeft=!openLeft}">
        <img src="../../assets/img/2dmap/pop_close_open.png" alt="" />
      </div>
      <div class="leftContent" v-show="openLeft">
        <div class="closeLeftBtn" v-show="openLeft" @click="()=>{openLeft=!openLeft}">
          <img src="../../assets/img/2dmap/pop_close_open.png" alt="" />
        </div>
        <div class="contentItem" >
          <div class="itemTitle">
            <div class="itemTitleText">飞行活动</div>
          </div>
          <div class="taskcontent_2d" >
            <div class="taskSearchBox" >
              <el-input
                placeholder="飞机型号,驾驶员,执照号,运营人,备注"
                v-model="searchTaskKeyWord "
                @keyup.enter.native="searchClick"
              >
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick"></i>
              </el-input>
            </div>

            <div class="listAll_2d" v-if="taskList.length !== 0">
              <div
                class="task-item_2d"
                v-for="item in taskList"
                :key="item.id"
                :title="'飞机号:'+item.uavSerial"
                @click="showPlanDetail(item)"
              >
                <div class="donePlan common" v-if="item.status==13||item.status==14">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #ee3f3f">已执行</div>
                  <div class="itemDetail"></div>
                </div>
                <div class="executePlan common" v-if="item.status==10||item.status==11||item.status==12">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #00ffff">执行中</div>
                  <div class="itemDetail"></div>
                </div>
                <div class="prePlan common" v-if="item.status==0||item.status==1||item.status==2||item.status==3||item.status==4||item.status==5||item.status==6||item.status==7||item.status==8||item.status==9">
                  <div  class="firstSpan" >{{ item.operatorSimpleName }}</div>
                  <div class="secondSpan" >{{ item.pilot }}</div>
                  <div class="thirdSpan" >
                    {{ item.type == 0 ? '观光' : item.type == 1 ? '巡检' : item.type == 2 ?'物流' :  item.type == 3 ?'应急':'物流' }}
                  </div>
                  <div style="color: #00aeff">待执行</div>
                  <div class="itemDetail"></div>
                </div>
              </div>
            </div>
            <div class="emptyWrap" v-if="taskList.length == 0">
              <Empty/>
            </div>

          </div>
        </div>
        <div class="contentItem10">
          <div class="itemTitle">
            <div class="itemTitleText">实时事件</div>
          </div>
          <div class="taskWrap">
            <div class="taskcontent_2d">
              <div class="listAll_2d"  style="height: 100%;overflow: initial" v-if="realTask.length !== 0">
                <div
                  class="task-item_2d_realTask"
                  :class="item.warning ? 'warn_2d' : 'alarm_2d'"
                  v-for="item in realTask"
                >
                  <div class="firstSpan">{{ item.warnMes }}</div>
                </div>

              </div>
              <Empty v-if="realTask.length == 0" :width="320" :height="260" ></Empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PlanDetail :taskForm="taskForm" :clickButton="clickButton"   @update:dialogVisible="updateDialogVisible" @closeForm="closeForm"
    ></PlanDetail>

    <div class='changeAirSpace'>
      <!-- 右侧 -->
      <div class="airSpaceBtnOne">
        <div
          title="空域"
          class="chooseBtn"
          :class="airSpaceChecked ? 'active' : ''"
          @click="
            airSpaceChecked = !airSpaceChecked;
            area = !area;
            btClick.space= area?btClick.space:false;
            btClick.grid= area?btClick.grid:false;
            handleBtClick('area',area);
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                airSpaceChecked
                  ? 'kong_yu_click'
                  : 'kong_yu_normal'
              }.png`)
            "
            alt=""
          />
        </div>
        <div
          title="设备"
          class="chooseBtn"
          :class="shibeiChecked ? 'active' : ''"
          @click="
            shibeiChecked = !shibeiChecked;
            equip=!equip
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                shibeiChecked ? 'she_bei_click' : 'she_bei_normal'
              }.png`)
            "
            alt=""
          />
        </div>
        <div
          title="航线/飞行"
          class="chooseBtn"
          :class="airPointLineChecked ? 'active' : ''"
          @click="
            airPointLineChecked = !airPointLineChecked;
            airPointLine = !airPointLine;
            btClick.airline= airPointLine?btClick.airline:false;
            handleBtClick('airPointLine',airPointLine);
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${
                airPointLineChecked ? 'fei_xing_click' : 'fei_xing_normal'
              }.png`)
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <div class='changeAirSpace1'>
      <!-- 右侧 -->
      <div class="airSpaceBtn" style="width: 100%;height: 100%;">

        <div v-show="area" class="area">
          <div
            class="chooseBtn"
            :class="btClick.space ? 'Active' : 'noActive'"
            @click="
              btClick.space= !btClick.space;
              btClick.airline= btClick.space?false:btClick.airline;
              btClick.grid= btClick.space?false:btClick.grid;
              handleBtClick('space',btClick.space);
            "
          >
            <div>空域</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.grid ? 'Active' : 'noActive'"
            @click="
              btClick.grid= !btClick.grid;
              btClick.airline= btClick.grid?false:btClick.airline;
              btClick.space= btClick.grid?false:btClick.space;
              handleBtClick('grid',btClick.grid);
          "
          >
            <div>数字网格</div>
          </div>
          <div class='changeWithOpenXianArea'></div>
        </div>
        <div v-show="equip" class="equip">
          <div class="chooseBtn" :class="btClick.adsb ? 'Active' : 'noActive'" @click="
              btClick.adsb= !btClick.adsb;
              handleBtClick('adsb',btClick.adsb);">
            <span class="point monitorPoint"> </span>
            <div>ADSB侦察</div>
          </div>
          <div class="chooseBtn" :class="btClick.firradar ? 'Active' : 'noActive'" @click="
              btClick.firradar= !btClick.firradar;
              handleBtClick('firradar',btClick.firradar);">
            <span class="point monitorPoint"> </span>
            <div>一次雷达</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.zhence ? 'Active' : 'noActive'" @click="
              btClick.zhence= !btClick.zhence;
              handleBtClick('zhence',btClick.zhence);"
          >
            <span class="point countermeasuwrePoint"> </span>
            <div>侦测设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.weather ? 'Active' : 'noActive'"  @click="
              btClick.weather= !btClick.weather;
              handleBtClick('weather',btClick.weather);"
          >
            <span class="point weatherPoint"> </span>
            <div>气象设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.video ? 'Active' : 'noActive'"
            @click="
              btClick.video= !btClick.video;
              handleBtClick('video',btClick.video);"
          >
            <span class="point videoPoint"> </span>
            <div>视频设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.navigator ? 'Active' : 'noActive'"
            @click="
              btClick.navigator= !btClick.navigator;
              handleBtClick('navigator',btClick.navigator);"
          >
            <span class="point navigationPoint"> </span>
            <div>导航设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.communicator ? 'Active' : 'noActive'"
            @click="
              btClick.communicator= !btClick.communicator;
              handleBtClick('communicator',btClick.communicator);"
          >
            <span class="point communicationPoint"> </span>
            <div>通信设备</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.range ? 'Active' : 'noActive'"
            @click="
              btClick.range= !btClick.range;
              handleBtClick('range',btClick.range);"
          >
            <div>设备范围</div>
          </div>
          <div class='changeWithOpenXianArea'>

          </div>
        </div>
        <div v-show="airPointLine" class="airPointLine">
          <div
            class="chooseBtn"
            :class="btClick.airline ? 'Active' : 'noActive'" @click="
              btClick.airline= !btClick.airline;
              btClick.space= btClick.airline?false:btClick.space;
              btClick.grid= btClick.airline?false:btClick.grid;
              handleBtClick('airline',btClick.airline);"
          >
            <div>航线</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.track ? 'Active' : 'noActive'" @click="
              btClick.track= !btClick.track;
              handleBtClick('track',btClick.track);"
          >
            <div>航迹</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.marker ? 'Active' : 'noActive'" @click="
              btClick.marker= !btClick.marker;
              handleBtClick('marker',btClick.marker);"
          >
            <div>标牌</div>
          </div>
          <div
            class="chooseBtn"
            :class="btClick.detailMarker ? 'Active' : 'noActive'"
            @click="
              btClick.detailMarker= !btClick.detailMarker;
              handleBtClick('detailMarker',btClick.detailMarker);"
          >
            <div>详细标牌</div>
          </div>
          <div class='changeWithOpenXianArea'>

          </div>
        </div>
      </div>

    </div>

    <div  style="width: 900px;z-index: 10000;left: 30%;position: absolute;bottom: 5px" v-if=showConfigdence popper-class="confidence-popover">
      <div class="confidence-image-container">
        <div style="height: 20px;color: #409eff;font-weight: bold;text-align: right;cursor: pointer" @click="showConfigdence=false;"><span>X</span></div>
        <div class="confidence-table-image">
          <div class="table-header">
            <div class="header-cell">影响因素</div>
            <div class="header-cell">说明</div>
            <div class="header-cell">权重</div>
            <div class="header-cell">分值</div>
            <div class="header-cell">描述</div>
            <div class="header-cell">得分</div>
          </div>
          <div class="table-body">
            <div v-for="(item, index) in formatTableData(configdence)" :key="index" class="table-row">
              <div class="body-cell">{{ item.name }}</div>
              <div class="body-cell">{{ item.illustrate }}</div>
              <div class="body-cell">{{ Math.floor(item.weight*100) }}%</div>
              <div class="body-cell score-options">
                <div v-for="scoreOption in getScoreOptions(item.key)" :key="scoreOption.score"
                     :class="['score-option', { 'score-selected': scoreOption.score == item.score }]">
                  {{ scoreOption.score }}
                </div>
              </div>
              <div class="body-cell description-cell">
                <div v-for="scoreOption in getScoreOptions(item.key)" :key="scoreOption.score"
                     :class="['description-option', { 'description-selected': scoreOption.score == item.score }]">
                  {{ scoreOption.description }}
                </div>
              </div>
              <div class="body-cell score-result">{{ (item.weight * item.score) }}</div>
            </div>
          </div>
          <div class="table-footer">
            <div class="footer-cell">总得分</div>
            <div class="footer-cell"></div>
            <div class="footer-cell">100%</div>
            <div class="footer-cell"></div>
            <div class="footer-cell"></div>
            <div class="footer-cell total-score">{{ getTotalScore(configdence) }}</div>
          </div>
        </div>
      </div>
      <div slot="reference" class="name-wrapper">
        {{ configdence?JSON.parse(configdence).weightedScore:'-' }}
      </div>
    </div>
  </div>
</template>

<script>
import PlanDetail from "../../common/PlanDetail";
import Empty from "../../common/Empty.vue";
export default {
  name: "ThreedTaskControl",
  components: {
    PlanDetail,
    Empty
  },
  data() {
    return {
      showConfigdence:false,
      configdence:{},
      planViewData:{},//飞行概览数据
      planActivity:{},//飞行活动数据
      aircraftData:{detail:[]},//飞行器数据
      taskForm:{},
      clickButton:false,
      searchTaskKeyWord:'',
      taskList:[],
      timeInfo: {
        currentTime: "10:04:06",
        date: "2020-10-20",
        weekday: "星期一"
      },
      chartType: 1,//右侧折线图切换1.运行小时数2.运行架次3.运行里程
      leftTop:null,
      rightCenter:null,
      rightBottom:null,
      rightTop:null,
      rightTopData:[],
      leftTopData:[],
      rightCenterData:[],
      rightBottomData:[],
      bottomClick:'2',
      runTask: [], //执行中计划
      preTask: [], //待执行计划
      doneTask: [], //已执行计划
      realTask:[],//实时事件
      changeRunTask: [], //处理后的计划
      searchDoneTask:'',
      searchRealTask:'',
      searchPreTask:'',
      // 存储被点击的id
      startIds:[],
      changeIds:[],
      downIds:[],
      facilitiesData:{},//地面基础设施数据
      loginUrl:!location.hostname.toString().includes('192.168.205')?'http://220.248.31.148:9601':"http://192.168.205.105:9601",//本地地址
      inspectionHistory:{arr:[]},//巡检历史统计数据
      inspectionWeek:{},//巡检当周统计数据
      inspectionDefect:[],//巡检缺陷史统计数据
      inspectionKey:'e3dea0f5-37f2-4d79-ae58-490af3228069',//巡检key
      openLeft:true,//是否展开左侧计划列表
      ws: null,
      airSpaceChecked: false,
      shibeiChecked: false,
      airPointLineChecked: false,
      area: false,
      equip: false,
      airPointLine: false,
      btClick:{
        space:false,
        grid:false,
        adsb:false,
        firradar:false,
        zhence:false,
        weather:false,
        video:false,
        navigator:false,
        communicator:false,
        range:false,
        airline:false,
        track: true,
        marker: true,
        detailMarker:false
      },
      configdenceEnu:{
        groundPersonnelSafety:{
          name: "地面人员安全",
          illustrate:'无人机坠地后，造成的人员伤害的概率，与人口密度和暴露程度成正比',
        },
        groundFacilitySafety:{
          name: "地面设施安全",
          illustrate:'无人机坠地后对城市设施造成损坏的概率，例如广播通信基站、电塔设施等',
        },
        searchDifficulty:{
          name: "搜寻难度",
          illustrate:'发生坠机事故后，对无人机及货物的回收难度',
        },
        secondaryDamage:{
          name: "次生伤害",
          illustrate:'发生坠机事故后，可能引发次生伤害的概率。例如电池燃烧引发火灾造成水体污染等事故。',
        },
        meteorologicalEnvironment:{
          name: "气象环境",
          illustrate:'航线区域发生特殊气象条件后，对运行造成影响。例如在江面不稳定的强气流，雾气等',
        },
        electromagneticEnvironment:{
          name: "电磁环境",
          illustrate:'运行中受到电磁干扰，例如 GPS信号干扰、操控链路干扰等',
        },
        obstacleEnvironment:{
          name: "障碍物环境",
          illustrate:'运行中遭遇临时性障碍物，具有不确定性。例如塔吊、正在建造的楼房等',
        },
        navigationAbilityRoute:{
          name: "导航能力（航线）",
          illustrate:'根据卫星导航性能，地面辅助导航性能进行综合定义。其中卫星导航性能是评估的主要依据，地面辅助导航性能可以作为卫星导航的补充',
        },
        navigationAbilityLandingPoint:{
          name: "导航能力（起降点）",
          illustrate:'起降点的导航性能，主要考虑是否使用视觉导航技术，卫星导航性能的影响',
        },
        communicationPerformance:{
          name: "通信性能",
          illustrate:'根据移动通信网络覆盖信号强度进行定义',
        },
        monitoringPerformance:{
          name: "监视性能",
          illustrate:'监视方式包括雷达，人工/计算机视觉，无线电侦听等手段',
        },
        publicAcceptability:{
          name: "公众可接受性",
          illustrate:'公众接受度父类',
        },
        privacyFactor:{
          name: "隐私因素",
          illustrate:'按照对隐私影响的可接受程度区分',
        },
        noiseFactor:{
          name: "噪声因素",
          illustrate:'按照对无人机产生的噪声的可接受程度进行区分',
        },
      },
    };
  },
  watch:{
    runTask(){
      this.changeRunTask = this.runTask.map(v=>({...v,startChecked:false,changeChecked:false,downChecked:false}))
    }
  },
  mounted() {
    this.initWs();
    this.queryPlan();
    window.queryTaskTimer = setInterval(()=>{
      this.queryPlan();
    }, 20000);
    let _this=this;
    window.addEventListener("message", function (event){
      let data= event.data;
      if (data.code== 'confidence'){
        if (data.data.configdence){
          _this.configdence= data.data.configdence;
          _this.showConfigdence= true;
        }
        return;
      }
    }, false);
  },
  beforeDestroy(){
    clearInterval(window.queryTaskTimer)
  },
  methods:{
    formatTableData(data){
      if(data){
        const { weightedScore, ...restData } = JSON.parse(data);
        // 将剩余对象转换为对象数组
        const resultArray = Object.entries(restData).map(([key, value]) => ({
          name:this.configdenceEnu[key].name,//中文key
          key: key,           // 保留原始键名作为name属性
          illustrate: this.configdenceEnu[key].illustrate, // 描述
          score: value.score,  // 提取score属性
          weight: value.weight, // 提取weight属性
        }));
        return resultArray
      }else
        return []
    },
    // 获取所有分值选项
    getScoreOptions(key) {
      const allOptions = {
        groundPersonnelSafety: [
          { score: -1, description: '人口聚集或人员活动密集的区域,地面建筑物设施设备或树木难以对人员提供保护。如：道路、广场、体育场等' },
          { score: 1, description: '人口居住区或有人员活动非密集的区域，地面建筑物、设施设备或树木对人员提供一定保护。如：居住区、办公区等' },
          { score: 2, description: '人员活动较少的区域，地面建筑物、设施设备或树木对人员提供较强保护。如：荒地、河道绿化带等' }
        ],
        groundFacilitySafety: [
          { score: -1, description: '航线地面投影区域有较多、并且重要的城市基础设施。如：通信基站、铁塔等' },
          { score: 1, description: '航线地面投影区域有基础设施，但不易受到破不。如：桥梁、道路等' },
          { score: 2, description: '无城市基础设施区域' }
        ],
        searchDifficulty: [
          { score: -1, description: '存在事故后无法收回的区域。如：江面、湖泊等' },
          { score: 1, description: '较难找寻的区域。如：小面积水域、林区、建筑密集区等' },
          { score: 2, description: '视野开阔，易搜索的区域' }
        ],
        secondaryDamage: [
          { score: -1, description: '能造成二次伤害区域。如:易发生火灾和水污染的区域等' },
          { score: 1, description: '可能造成二次伤害区域。如:加油站、湖泊、河流等区域' },
          { score: 2, description: '不易引发二次伤害的区域' }
        ],
        meteorologicalEnvironment: [
          { score: -1, description: '气象条件复杂，常出现特殊气象。如:建筑物风口丘陵山区等' },
          { score: 1, description: '气象条件比较复杂，容易发生特殊气象。如:宽阔工面、湖面，丘陵山区等' },
          { score: 2, description: '气象较稳定，不易出现特殊气象。如:开阔平坦区域等' }
        ],

        electromagneticEnvironment: [
          { score: -1, description: '电磁环境复杂区域。如:广播通信基站密集区域、超高压线附近等' },
          { score: 1, description: '电磁环境较复杂区域。如:铁塔周围、一般等级高压线周围等' },
          { score: 2, description: '电磁环境较单一区域' }
        ],

        obstacleEnvironment: [
          { score: -1, description: '障碍物环境复杂。如:正在施工的塔吊、正在建设的工地等' },
          { score: 1, description: '障碍物环境较复杂。如:风筝密集区等' },
          { score: 2, description: '无障碍物变化地区' }
        ],
        navigationAbilityRoute: [
          { score: -1, description: '接收到的卫星数量小于 8颗' },
          { score: 1, description: '1min 内有丢星现象，但获取卫星数大于8颗' },
          { score: 2, description: '具备地面辅助导航设备，且1min内稳定获取卫星数于 12 颗' }
        ],
        navigationAbilityLandingPoint: [
          { score: -1, description: '卫星信号测量结果无法稳定获取卫星信号，或1min内稳定获取卫星数小于 8 颗'},
          { score: 1, description: '卫星信号测量结果无法保持无人机利用卫星定位信号实现定点(1 min 内不超过2 m范围)悬停，或1 min 内稳定获取卫星数大于等于 8 颗且小于 12颗' },
          { score: 2, description: '无人机具备视觉导航能力，卫星信号测量结果可以保持无人机利用卫星定位信号,实现定点(1min 内不超过2m范围)悬停，或具备地面辅助导航设备' }
        ],
        communicationPerformance: [
          { score: -1, description: '单网移动通信3G/4G/5G信号强度覆盖大于-85dBm，且人口密度存在波动，易造成信号拥堵' },
          { score: 1, description: '至少双网移动通信3G/4G/5G信号强度覆盖大于-85dBm，且人口密度存在波动，易造成信号拥堵' },
          { score: 2, description: '至少双网移动通信3G/4G/5G信号强度大于-85dBm，且人口密度无波动，易造成信号拥堵' }
        ],
        monitoringPerformance: [
          { score: -1, description: '不具备监视能力' },
          { score: 1, description: '可识别合作目标' },
          { score: 2, description: '可识别合作目标和非合作目标' }
        ],
        privacyFactor: [
          { score: -1, description: '隐私保护需求强区域。如：政府单位等' },
          { score: 1, description: '隐私保护需求较强区域。如：别墅区等敞开式私人活动场所等' },
          { score: 2, description: '无隐私保护需求区域。如：公共场所等' }
        ],
        noiseFactor: [
          { score: -1, description: '噪音敏感区域。如：学校、疗养院、别墅区、社区等' },
          { score: 1, description: '噪音较敏感区域。如：办公区、医院自然公园等' },
          { score: 2, description: '噪音不敏感区域。如：公共区域等' }
        ]
      };

      return allOptions[key] || [];
    },
    // 获取分值对应的描述（保留原有方法以兼容）
    getScoreDescription(key, score) {
      const options = this.getScoreOptions(key);
      const option = options.find(opt => opt.score == score);
      return option ? option.description : '未定义';
    },
    // 计算总得分
    getTotalScore(data) {
      if (!data) return '0.00';
      try {
        const parsedData = JSON.parse(data);
        return parsedData.weightedScore ? parsedData.weightedScore.toFixed(2) : '0.00';
      } catch (e) {
        return '0.00';
      }
    },
    // 生成随机字符串
    generateRandomString(length = 10) {
      const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    initWs(){
      let randomStr = this.generateRandomString();
      //this.ws = new WebSocket(`ws://192.168.205.192:8769/websocket/login/${randomStr}`); //线上
      this.ws = new WebSocket(`ws://${location.hostname}:9600/websocket/login/${randomStr}`); //线上
      this.ws.addEventListener('open', () => {
        console.log('ws连接成功');
        // 建立连接成功后发送token给后端
        // let token = sessionStorage.getItem('tokenId');
        // this.ws.send('Authorization: Bearer ' + token);
        // 发送屏幕对角线数据给后端
        // this.sendBounds();
      });
      this.ws.addEventListener('close', () => {
        console.log('ws连接关闭');
        // 连接断开后停止预测点的定时器
        if (window.predictionTimer) {
          clearInterval(window.predictionTimer);
          window.predictionTimer = null;
        }
      });
      this.ws.addEventListener('error', (err) => {
        console.log('ws连接错误', err);
      });
      this.ws.addEventListener('message', (e) => {
        let data = JSON.parse(e.data);
        let records = data.content;
        let realTask = [];//告警信息
        if (data.type == 1) {
          records.map(po => {
            if (po.warning || po.alarm) {
              let warnMes = `${po.uasID}在${po.routeName}上发生偏航${
                po.warning ? "预警" : "告警"
              }`;
              realTask.unshift({
                warnMes: warnMes,
                warning: po.warning,
                alarm: po.alarm,
                uasID: po.uasID
              });
            }
            if (po.black) {
              let warnMes = `${po.uasID}正在黑飞告警`;
              realTask.unshift({
                warnMes: warnMes,
                warning: 0,
                alarm: 1,
                uasID: po.uasID
              });
            }
            if (po.conflictsList && po.conflictsList.length) {
              //aow ture 告警 false 预警
              po.conflictsList.map(v => {
                realTask.unshift({
                  warnMes: v.conflict,
                  warning: !v.aow,
                  uasID: po.uasID
                });
              })
            }
          })
        } else if (data.type == 2) {
          realTask.unshift({
            warnMes: records.content,
            warning: records.alarmType == 0 ? 1 : 0,
          });
        } else if (data.type == 13||data.type == 14) {
          realTask.unshift({
            warnMes: data.content,
            warning: data.alarmType == 0 ? 1 : 0,
          });
        }
        this.realTask = realTask.concat(this.realTask);
        if(this.realTask.length>10){
          let num = this.realTask.length - 10
          for(let i = 0;i<num;i++){
            this.realTask.pop()
          }
        }
      });
    },
    showPlanDetail(info){
      console.log(info)
      this.taskForm = info
      this.clickButton = true
    },
    updateDialogVisible(newVal){
      this.clickButton = newVal
    },
    closeForm(value){
      this.clickButton = value
    },
    searchClick(v){
      this.queryPlan(v);
    },
    queryPlan() {
      this.getRequest(
        `/uav-task-server/plandto/queryPlanByConditionNoStatus?pagesize=100&keyWord=${this.searchTaskKeyWord}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            // let simpleArray = records.map(item => ({
            //   id: item.id,
            //   planSerial: item.planSerial,
            //   uavSerial: item.uavSerial,
            //   uavModel: item.uavModel,
            //   pilot: item.pilot,
            //   type: item.type,
            //   status: item.status,
            //   airpointList: item.airpointList
            // }));
            this.taskList = records;
          } else {
            this.taskList = [];
          }
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    sendMessageToIframe(code , data){
      let message = {code:code, data:data};
      let iframe = document.getElementById('mapframe');
      if (iframe.contentWindow) {
        // 发送消息到iframe
        iframe.contentWindow.postMessage(message, '*'); // 注意目标来源地址
      }
    },
    handleBtClick(key, value){
      let data={key:key, value:value};
      this.sendMessageToIframe(1, data);
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}


#dashboardIndex {
  z-index: 3;
  width: 100%;
  height: 100%;
  position: relative;
}
/* 两侧以及底部顶部z-index 为4  header为3 高于地图 */
.mapWrap{

  z-index: 2;
  position: absolute;
  top:80px;
  left:0;
  width: 100%;
  height: calc(100% - 80px);
  overflow: hidden;
}
.headerContent{
  pointer-events:none;
  z-index: 3;
  width: 100%;
  background-size: 100%;
  display: flex;
  justify-content: end;
  padding: 16px 22px 0 17px;
//position: relative;
  position: absolute;
}
@media screen and (max-width: 1920px) {
  .headerContent{
    height: 144px;
    background-image: url("../../assets/img/dashboard/header.png");
  }
  .headerMiddle{
    font-size: 66px;
    line-height: 60px;
  }
}
@media screen and (min-width: 2000px) {
  .headerContent{
    height: 240px;
    background-image: url("../../assets/img/dashboard/header_2880.png");
  }
  .headerMiddle{
    line-height: 100px;
    font-size: 100px;
  }
}
.headerLeft{
  position: absolute;
  left: 17px;
  top: 16px;
  z-index: 5;
  display: flex;
}
.headerBtn{
  width: 120px;
  height: 40px;
  background-image: url("../../assets/img/dashboard/menu_btn.png");
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0,0,0,0.18);
  line-height: 40px;
  cursor: pointer;
}
.headerMiddle{
//width: 1388px;
  position: absolute;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 2.64px;
  text-shadow: 2px 3.46px 3.68px 0.32px rgba(16,9,0,0.50);
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.headerRight{
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #f0f0f0;
  letter-spacing: 1.4px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 10px;
}

.contentWrap{
  position: absolute;
  top: 80px;
  height: calc(100% - 80px);
  width: 100%;
}
.leftContent{
  top: 0;
  left: 0;

}
.rightContent{
  top: 0;
  right: 0;
}
.leftContent,
.rightContent{
  z-index: 4;
  background: rgba(1,10,18, 0.68);
  height: 100%;
//width: 20%;
  width: 400px;
  position: absolute;
  display: flex;
  flex-direction: column;
//overflow: auto;
}

.rightContent{
  right: 0;

}
.bottomContent{
  z-index: 4;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: calc(100% - 800px);
  justify-content: space-around;
}
.bottomBtn,.bottomBtnClick{
  cursor: pointer;
  text-align: center;
  line-height: 74px;
  width: 233px;
  height: 74px;
  font-size: 32px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 1.6px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
}
.bottomBtn{
  background-image: url("../../assets/img/dashboard/normal.png");
}
.bottomBtnClick{
  background-image: url("../../assets/img/dashboard/click.png");
}
.contentItem{
  height: 66%;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}
.contentItem10{
  height: 33%;
//min-height: 100px;
  display: flex;
  flex-direction: column;
}
.contentItem30{
  flex: 30;
  max-height: 26%;
  display: flex;
  flex-direction: column;
}
.itemTitle{
  height: 50px;
  background-image: url("../../assets/img/2dmap/pop_bg.png");
  background-size: 80% 38px;
  padding-left: 44px;
  background-repeat: no-repeat;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 12px;
}
.barChart,.lineChart{
  flex: 1;
  margin-top: 11px;
}
.inspectionContentWrap{
  padding: 23px 21px 0 29px;
  height: calc(100% - 50px);
}
#patrolHistory{
  background-image: url('../../assets/img/dashboard/shuju_bg2.png');
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
#patrolHistory .historyItem{
  width: 110px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
#patrolHistory .historyItem:not(:last-child){
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;

}
#patrolDefect{
  padding: 13px 23px 23px 34px;
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}
#patrolDefect .dayItem{
  width: 120px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
.data{
//margin-bottom: 5px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
}
.text{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.checkData{
  border-bottom: 2px solid ;
  border-image: linear-gradient(0deg, rgba(255, 200, 119, 0.99), rgba(255, 200, 119, 0.00) 49%, rgba(238, 175, 84, 0.00)) 2 2;
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-bottom: 8px;
}
.separate{
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;
}
.alarmWrap{
  height: calc(100% - 50px);
  padding: 0 33px 23px 27px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.alarmContentWrap{
  display: flex;
  justify-content: space-between;
}
.alertItem{
  background-size: 100%;
  position: relative;
  width: 140px;
  height: 132px;
}
.alertItemText{
  position: absolute;
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  bottom: 6px;
  left: 34px;
}
.alertItemFigure{
  height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1px 1.73px 5px 2px rgba(20,10,0,0.68);
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
}
#heiFeiItem{
  background-image: url("../../assets/img/dashboard/hei_fei.png");
}
#chongTuItem{
  background-image: url("../../assets/img/dashboard/chong_tu.png");
}
#pianHangItem{
  background-image: url("../../assets/img/dashboard/pian_hang.png");
}
#zhengChangItem{
  background-image: url("../../assets/img/dashboard/zheng_chang.png");
}
.basic{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 50px);
  padding: 30px 34px 27px 24px;
}
.equipment{
  display: flex;
}
.up{
  background-image: url(../.././assets/img/dashboard/tubiao_chengse.png);
  background-position: top left;
  background-repeat: no-repeat;
  height: 98px;
  width: 98px;
  margin-right: 60px;
  position: relative;
}
.watch{
  background-image: url(../.././assets/img/dashboard/tubiao_jinse.png);
  background-position: top left;
  background-repeat: no-repeat;
  height: 98px;
  width: 98px;
  position: relative;
}
.datas{
  position: absolute;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
//text-align: left;
  color: #ffffff;
//z-index: 99;
  left: 57px;
  top: 10px;
}
.equipment .texts{
  min-width: 130px;
  position: absolute;
  left: 58px;
  top: 40px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
//text-align: left;
  color: #ebebeb;
//z-index: 99;
}
.states{
  display: flex;
}
.states .texts{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.down{
  width: 159px;
  height: 132px;
  background: rgba(23,11,1,0.50);
  border: 2px solid rgba(255,200,119,0.30);
  margin-top: 5px;
}
.stateone{
  display: flex;
  margin-top: 12px;
}
.txt{
  width: 100%;
  height: 42%;
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ffffff;
  padding-left: 11px;
  padding-top: 15px;
}
.numbers{
  width: 45px;
  height: 17px;
  line-height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-left: 45px;
}
.numberstwo{
  width: 20px;
  height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ff5555;
  margin-left: 45px;
}
.fa-mouse-pointer {
  cursor: pointer;
}
.lineChartWrap{
  flex:1;
  height: calc(100% - 92px);
}
.linkBtn{
  position: relative;
}
.linksGroup{
  position: absolute;
  left: 35px;
  top:-60px;
  width: 170px;
  height: 55px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.linksGroup a{
  line-height: 22px;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  font-size: 24px;
  font-family: 'PangMenZhengDao-3', 'PangMenZhengDao-3-Regular';
  font-weight: 400;
  text-decoration: underline;
  text-align: left;
  color: #ffc877;
}
.taskcontent_2d{
  padding: 5px 10px;
  height: 100%;
  overflow: auto;
}
.taskSearchBox{
  margin-bottom: 12px;
}

>>>.taskSearchBox .el-input__inner {
  color: #FFFFFF;
  border-radius: 0;
  border: none;
}

.taskSearchBox >>>input{
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: calc(100% - 5px);
  height: 32px;
  background: rgba(0, 174, 255, 0.5);
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
}
.taskSearchBox  /deep/.el-input__icon{
  height: 32px;
//border: 1px solid red;
  right: 10px;
  line-height: 38px;
  cursor: pointer;

}
.taskSearchBox input{

}
.taskSearchBox input >>>i{
//border: 1px solid red;
  position: absolute;
  top: 7px;
  bottom: 7px;
  right: 32px;
}
.task-item_2d {
  margin: 16px 0;
  cursor: pointer;
}
.task-item_2d .common{
  background: rgba(1, 10, 18, 0.68);
  height: 38px;
  color: #FFFFFF;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 10px
}

.task-item_2d .donePlan {
  border: 2px solid #ee3f3f;
}

.task-item_2d .prePlan {
  border: 2px solid #00aeff;
}

.task-item_2d .executePlan {
  border: 2px solid #00ffff;
}
.taskWrap{
  background: rgba(1, 10, 18, 0.68);
  border-radius: 6px;
  padding: 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: calc(100% - 62px)
}

.common .firstSpan{
  min-width: 90px;
}
.common .secondSpan{
  min-width: 50px;
}
.common .thirdSpan{
  min-width: 40px;
}
.common .itemDetail{
  width: 6px;
  height: 10px;
  background-image: url("../../assets/img/2dmap/xiang_qing.png");
}
/*.task-item_2d  .donePlan{
  background: #220c03;
}
.task-item_2d  .prePlan{
  background: #2d0a0a;
}
.task-item_2d  .executePlan{
  background: #2f1d0b;
}*/
.prePlan:hover{
  box-shadow: 0px 0px 6px 1px #ff5555 inset;
}
.executePlan:hover{
  box-shadow: 0px 0px 6px 1px #ffc877 inset;
}
.donePlan:hover{
  box-shadow: 0px 0px 6px 1px deepskyblue inset;
}
.task-item_2d .planeBtns{
  padding-right: 5px;
  display: flex;
}
.emptyContent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
  width: 100%;
  background: #170b01;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
}
.planeBtns .planTobtn{
  display: flex;
  align-items: center;
  position: relative;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  cursor: pointer;
  z-index: 1001;
}
.planeBtns .planTobtn:not(:last-child){
  margin-right: 6px;
}
.planTobtn img{
  width: 26px;
  height: 26px;
}
.planeBtns .planTobtn span {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 35px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  z-index: 100;
}
.planeBtns .planTobtn:hover span {
  display: block;
}
.listAll_2d{
  height: calc(100% - 44px);
  padding: 0 10px;
  background: rgba(1, 10, 18, 0.50);
  overflow: auto;
}
.emptyWrap{
  width: 100%;
  height: calc(100% - 44px);
}
#rightOverlay {
  width: 400px !important;
}
*{
  user-select: none;
}
.flyTop {
  padding: 13px 23px 23px 34px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 22px 18px 22px;
  width: 350px;
  height: 92px;
  /* background-image: url("../../assets/img/2dmap/shuju_bg.png"); */
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}

.flyTopTop div:nth-child(1) {
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  text-align: left;
}

.flyTopTop div:nth-child(2) {
  width: 100px;
  height: 15px;
}
.fa-mouse-pointer {
  cursor: pointer;
}
.canChangeFigure {
  height: 40px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;

}
.flyTop .flyText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
#fenge {
  display: block;
  width: 70px;
  height: 0;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}
.flyTop .unActiveFigure {
  margin-top: 4px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
  margin-bottom: 11px;
}
.flyTop .erectFenge {
  width: 0px;
  height: 74px;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}
.RightBottomBottom {
  width: 306px;
  height: 38px;
  /* background: rgba(23, 11, 1, 0.50); */
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  background-image: url(../../../src/assets/img/2dmap/paihang_bg.png);
}
.shortShuFenge {
  margin-left: 2px;
  width: 4px;
  height: 28px;
  margin-right: 6px;
}
.rightBottomBottomText {
  width: 100px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.processStyle {
  width: 155px;
  height: 6px;
  margin-right: 10px;
  margin-left: 10px;
}
.RightBottomBottomFigure {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.titleShuFenge {
  margin-left: 2px;
  width: 4px;
  height: 38px;
  margin-right: 6px;
}
.inspectionContentWrap .rightBottomTop .titleBgL {
  background: linear-gradient(90deg, rgba(255, 140, 77, 0.50) 0%, rgba(255, 140, 77, 0.00) 100%);
}

.inspectionContentWrap .rightBottomTop .titleBgR {
  background: linear-gradient(90deg, rgba(255, 85, 85, 0.50) 0%, rgba(255, 85, 85, 0.00) 100%);
}
.inspectionContentWrap .rightBottomTop .titleBgL,
.inspectionContentWrap .rightBottomTop .titleBgR {
  width: 140px;
  height: 38px;
  display: flex;
  align-items: center;
}
.ordinaryText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
  margin-right: 10px;
}
.contentFigure {
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
}
.ordinaryFigure {
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ebebeb;
}
.openLeftBtn{
  cursor: pointer;
  position: absolute;
  left: 5px;
  top:8px;
  z-index: 10;
}
.closeLeftBtn{
  cursor: pointer;
  position: absolute;
  right: -50px;
  top:2px;
}

.changeWithOpen {
  position: absolute;
//top: 495px;
//top: 470px;
  top: calc(50% + 40px );
  transform: translateY(-50%);
  right: 370px;
  width: 48px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

/* 右侧 */
.changeAirSpace {
  position: absolute;
//top: 495px;
  top: 460px;
  right: 12px;
  width: 50px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

.airSpaceBtnOne .chooseBtn {
  width: 100%;
  height: 48px;
  text-align: center;
  position: relative;
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  z-index: 1004;
}

.changeWithOpen1 {
  position: absolute;
//top: 495px;
  top: calc(50% + 40px );
  transform: translateY(-50%);
  right: 405px;
  width: 156px;
  overflow: auto;
//height: 620px;
  max-height:  calc(100% - 360px);
  cursor: pointer;
  z-index: 1003;
  background: transparent;

}

.changeAirSpace1 {
  position: absolute;
//top: 495px;
  top: 250px;
  right: 56px;
  width: 150px;
  height: 620px;
  cursor: pointer;
  z-index: 1003;
  background: transparent;
}

.airSpaceBtn .chooseBtn {
  width: 100%;
  height: 34px;
  text-align: center;
  position: relative;
  align-items: center;
  display: flex;
  padding-left: 15px;
  margin-bottom: 10px;
  z-index: 1004;
}


.changeWithOpen1 .airSpaceBtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.airSpaceBtn {
  position: relative;
}

.airSpaceBtn .chooseBtn img {
  position: absolute;
  top: 10px;
  right: 0px;
  margin-bottom: 15px;
}

.changeWithOpen1 .airSpaceBtn .chooseBtn {
  width: 100%;
}

.changeWithOpen .airSpaceBtn .chooseBtn {
  margin-bottom: 24px;
}

.area {
  position: relative;
  width: 156px;
  height: 90px;
}

.equip {
  position: relative;
  width: 156px;
  height: 350px;
}

.population {
  position: relative;
  width: 156px;
  height: 45px;
}
.airPointLine{
  position: relative;
  width: 156px;
  height: 180px;
}
.Active {
  background-image: url(../../assets/img/2dmap/er_ji_click.png);
  background-repeat: no-repeat;
}

.noActive {
  background-image: url(../../assets/img/2dmap/er_ji_normal.png);
  background-repeat: no-repeat;
}

.changeWithOpenXianArea {
  position: absolute;
//top: 495px;
  /* top: 5px; */
  top: 0;
  right: 40px;
  width: 5px;
  height: 100%;
  cursor: pointer;
  z-index: 1003;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}
.chooseBtn div {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  /* margin-bottom: 5px; */
}


.changeAirSpace1 .airSpaceBtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.changeWithOpenXianEquip {
  position: absolute;
//top: 495px;
  top: 0;
  right: 40px;
  width: 5px;
  height: 250px;
  cursor: pointer;
  z-index: 1003;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}

.changeWithOpenXianAirPointLine {
  position: absolute;
//top: 495px;
  top: 0;
  /* todo */
  right: 40px;
  width: 5px;
  height: 120px;
  cursor: pointer;
  z-index: 1003;
  background-size: contain;
  background-image: url(../../assets/img/2dmap/she_bei_er_ji_bar.png);
}


.task-item_2d_realTask{
  display: flex;
  width: 100%;
  height: auto;
//line-height: 38px;
  background: #170b01;
  border-radius: 6px;
  margin-bottom: 6px;
  align-items: center;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
  box-sizing: border-box;
  padding-left: 5px;
}
.listAll_2d .warn_2d{
  background: linear-gradient(
    90deg,
    rgba(255, 150, 0, 0.8),
    rgba(71, 160, 255, 0.2)
  );
}
.listAll_2d .alarm_2d {
  background: linear-gradient(
    90deg,
    rgba(218, 0, 1, 0.8),
    rgba(71, 160, 255, 0.11)
  );
}

.chooseBtn .point{
  position: absolute;
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 6px;
  left: 5px;
  margin: auto;
}
.monitorPoint{
  background: #ffb11b;
}
.countermeasuwrePoint{
  background: #ee30ff;
}
.weatherPoint{
  background: #00fffc;
}
.videoPoint{
  background: #ff391f;
}
.navigationPoint{
  background: #00b1fb;
}
.communicationPoint{
  background: #00ffae;
}

.name-wrapper {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
>>> .blue-table-container {
  width: 100%;
  overflow-x: auto;
}

.confidence-image-container {
  width: 100%;
  background: #1a1a2e;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  border: 1px solid #2a2a3e;
}

.confidence-table-image {
  background: #16213e;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid #2a2a3e;
}

.table-header {
  display: flex;
  background: #0f3460;
  color: white;
  font-weight: bold;
  font-size: 12px;
  border-bottom: 1px solid #2a2a3e;
}

.header-cell {
  flex: 1;
  padding: 12px 8px;
  font-size: 14px;
  text-align: center;
  border-right: 1px solid #2a2a3e;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-cell:last-child {
  border-right: none;
}

.table-body {
  max-height: 400px;
  overflow-y: auto;
  background: #16213e;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #2a2a3e;
  transition: background-color 0.2s;
}

.table-row:hover {
  background-color: #1e2a4a;
}

.table-row:nth-child(even) {
  background-color: #1a1a2e;
}

.body-cell {
  flex: 1;
  padding: 10px 8px;
  text-align: center;
  font-size: 13px;
  border-right: 1px solid #2a2a3e;
  min-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  line-height: 1.3;
  color: #e8e8e8;
}

.body-cell:last-child {
  border-right: none;
}

.score-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 4px;
}

.score-option {
  height: 30px;
  width: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
  font-size: 10px;
  text-align: center;
  background-color: #2a2a3e;
  color: #b0b0b0;
  border: 1px solid #3a3a4e;
  cursor: default;
  transition: all 0.2s;
}

.score-option.score-selected {
  background-color: #409eff;
  color: white;
  border-color: #409eff;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
}

.description-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 4px;
}

.description-option {
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 12px;
  text-align: left;
  background-color: #2a2a3e;
  color: #a0a0a0;
  border: 1px solid #3a3a4e;
  line-height: 1.2;
  transition: all 0.2s;
  min-height: 20px;
  display: flex;
  align-items: center;
}

.description-option.description-selected {
  background-color: #1e3a5f;
  color: #409eff;
  border-color: #409eff;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.score-result {
  font-weight: bold;
  color: #67c23a;
  background-color: #1e3a1e;
  border-radius: 4px;
  margin: 2px;
  border: 1px solid #2a4a2a;
}

.table-footer {
  display: flex;
  background: #0f3460;
  color: white;
  font-weight: bold;
  font-size: 12px;
  border-top: 1px solid #2a2a3e;
}

.footer-cell {
  flex: 1;
  padding: 12px 8px;
  text-align: center;
  border-right: 1px solid #2a2a3e;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-cell:last-child {
  border-right: none;
}

.total-score {
  font-size: 14px;
  font-weight: bold;
  background-color: #409eff;
  color: white;
  border-radius: 4px;
  margin: 2px;
  padding: 4px 8px;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
}

>>>.el-popover {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/home/ThreedTaskControl.vue